/**
 * Check if there are any errors in the current syllabus items
 * @param items {Array}
 * @return {Array}
 */
export const checkItemErrors = items => {
	if (!items) throw Error('Items array required in order to check for errors');
	
	// Find the line number occurrences of each code
	const codeLines = items.reduce((codeLines, item, index) => {
		codeLines[item.code] = codeLines[item.code] || [];
		codeLines[item.code].push(index + 2); // +2 taking header and array 0 into account
		return codeLines;
	}, {});
	
	// Reduce line number occurrences down to a list of errors
	return Object.keys(codeLines).reduce((itemErrors, code) => {
		// If more than one occurrence of a code, add it to the errors list/
		if (codeLines[code] && codeLines[code].length > 1) {
			itemErrors.push({
				code,
				lines: codeLines[code]
			});
		}
		return itemErrors
	}, []);
};

/**
 * Check if there are any errors in the current syllabus content
 * @param content {Array}
 * @param items {Array}
 * @return {*[]} Will return two arrays, one for errors and one for orphans
 */
export const checkContentErrors = (content, items) => {
	const itemCodes = items.reduce((itemCodes, item) => {
		itemCodes[item.code] = itemCodes[item.code] || true;
		return itemCodes;
	}, {});
	
	// Find the line number occurrences of dupes and orphans
	const orphanContentLines = {};
	const dupeContentLines = content.reduce((dupeContentLines, c, index) => {
		dupeContentLines[c.code] = dupeContentLines[c.code] || [];
		dupeContentLines[c.code].push(index + 2); // +2 taking header and array 0 into account
		if (!itemCodes[c.item_code]) {
			orphanContentLines[c.code] = orphanContentLines[c.code] || [];
			orphanContentLines[c.code].push(index + 2);
		}
		return dupeContentLines;
	}, {});
	
	// Reduce line number occurrences down to a list of errors and orphans
	return [
		Object.keys(dupeContentLines).reduce((contentErrors, code) => {
			if (dupeContentLines[code] && dupeContentLines[code].length > 1) {
				contentErrors.push({
					code,
					lines: dupeContentLines[code]
				});
			}
			return contentErrors;
		}, []),
		Object.keys(orphanContentLines).map(code => {
			return {
				code,
				lines: orphanContentLines[code]
			};
		})
	];
};


// WEBPACK FOOTER //
// ./src/syllabus/syllabus.utils.js